<template>
  <div>
    <div >
      <div class="form-inline">
        <h2 >網頁內容</h2>
      </div>
      <div class="row" style="width:800px;padding-left: 50px">
        <div class="col-3" >
          <a role="button" class="btn btn-info " @click="gotoTextAreaEditor(WebContent_QueryType_4_Index)">首頁</a>
        </div>
        <div class="col-3">
        </div>
      </div>
      <div class="row" style="width:800px;padding-left: 50px">
        <div class="col-3" >
          <a role="button" class="btn btn-info " @click="gotoHtmlEditor(WebContent_QueryType_1_About)">道場簡介</a>
        </div>
        <div class="col-3">
        </div>
      </div>
      <div class="row" style="width:800px;padding-left: 50px">
        <div class="col-3" >
          <a role="button" class="btn btn-info " @click="gotoHtmlEditor(WebContent_QueryType_3_SignWording)">灶君靈籤</a>
        </div>
        <div class="col-3">
        </div>
      </div>
      <div class="row" style="width:800px;padding-left: 50px">
        <div class="col-3" >
          <a role="button" class="btn btn-info " @click="gotoHtmlEditor(WebContent_QueryType_5_BookingStep1)">點燈護靈注意事項</a>
        </div>
        <div class="col-3">
        </div>
      </div>
      <div class="row" style="width:800px;padding-left: 50px">
        <div class="col-3" >
          <a role="button" class="btn btn-info " @click="gotoHtmlEditor(WebContent_QueryType_9_BookingStep5)">點燈護靈_付款結果</a>
        </div>
        <div class="col-3">
        </div>
      </div>
      <div class="row" style="width:800px;padding-left: 50px">
        <div class="col-3" >
          <a role="button" class="btn btn-info " @click="gotoHtmlEditor(WebContent_QueryType_10_Ebooks)">道堂出版電子刊物</a>
        </div>
        <div class="col-3">
        </div>
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
/**

 **/
import {
  WebContent_QueryType_1_About,
  WebContent_QueryType_3_SignWording,
  WebContent_QueryType_4_Index,
  WebContent_QueryType_5_BookingStep1,
  WebContent_QueryType_9_BookingStep5,
  WebContent_QueryType_10_Ebooks,
} from "./js/fireGodsDeclare";




export default {
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{},
      isSettingEnable:false,
      WebContent_QueryType_1_About:WebContent_QueryType_1_About,
      WebContent_QueryType_3_SignWording:WebContent_QueryType_3_SignWording,
      WebContent_QueryType_4_Index:WebContent_QueryType_4_Index,
      WebContent_QueryType_5_BookingStep1:WebContent_QueryType_5_BookingStep1,
      WebContent_QueryType_9_BookingStep5:WebContent_QueryType_9_BookingStep5,
      WebContent_QueryType_10_Ebooks:WebContent_QueryType_10_Ebooks,
    };
  },
  methods: {
    loadData() {

    },
    gotoHtmlEditor(queryType){
      this.$router.push({ name: 'ContentEditSimple', query: { QueryType: queryType }})
    },
    gotoTextAreaEditor(queryType){
      this.$router.push({ name: 'ContentEditTextArea', query: { QueryType: queryType }})
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>

</style>
